import { ChildComponent } from "@/types";
import {  ConditionalValue, Tabs } from "@chakra-ui/react";
import { JSX, useState } from "react";

const TabsComponent = (props: any) => {

        // the first child will be tab labels so skip it
        // const children: ChildComponent[] = props.children.slice(1, props.children.length)
        const variant: ConditionalValue<"outline" | "line" | "subtle" | "enclosed" | "plain" | undefined> = props.variant
        const labels: string[] = props.labels
        const children: JSX.Element[] = props.children

        const childComponents: ChildComponent[] = []

        const [openTab, setOpenTab] = useState<string | null>(labels[0])

        for( let i = 0; i < children.length; i++ ) {
            childComponents.push(
                {
                    child: children[i],
                    index: i
                }
            )
        }
        
        return (
            <Tabs.Root 
                key={"outline"} 
                variant={variant} 
                value={openTab} 
                onValueChange={(e) => setOpenTab(e.value)} 
                fitted>
                <Tabs.List>
                    {labels.map((label: string) => {
                        return (
                            <Tabs.Trigger value={label}>
                                {label}
                            </Tabs.Trigger>
                        )
                    })}
                </Tabs.List>
                {childComponents.map((child: ChildComponent) => {
                        return (
                            <Tabs.Content value={labels[child.index]}>
                                {child.child}
                            </Tabs.Content>
                        )
                })}
            </Tabs.Root>
        )


}

export default TabsComponent;